import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SentEmailPage } from './sent-email.model';

/**
 * TVG-313: HTTP wrapper for the contact's sent-email list. Read-only — rows are
 * written by the server when an email actually goes out.
 */
@Injectable({
  providedIn: 'root',
})
export class SentEmailService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  listForContact(contactId: number | string, pageNum = 1, pageSize = 25): Observable<SentEmailPage> {
    const params = new HttpParams()
      .set('pageNum', pageNum)
      .set('pageSize', pageSize);

    return this.http.get<SentEmailPage>(
      `${this.apiUrl}/api/contacts/${contactId}/sent-emails`,
      { params },
    );
  }
}
